export { ServicingPage } from './lib/servicing-page'
export { getStaticProps } from './lib/get-static-props'
export * from './lib/design-system/badge'

// Development-only, kept out of the component barrel so the badge folder
// stays portable to the design system.
export { BadgeGallery } from './lib/design-system/badge/badge.gallery'
